import { RHFTextField } from "@components/hook-form";
import { defineForm, MANUAL_DOC_ENDPOINTS } from "../../../core";
import { defaultVendorProfileMapper } from "../../../core/engine/defaultMappers";
import { vendorPreserve } from "../../_shared/preserve";
import { deliveryNoteSchema } from "./schema";

export const deliveryNoteConfig = defineForm({
  id: "delivery_note",
  createEndpoint: MANUAL_DOC_ENDPOINTS.DELIVERY_NOTE,
  permission: "ManualDocumentsDN_Write",
  seriesPermission: "ManualDocumentsSeries_Read",
  documentClass: "DeliveryNote",
  accountClass: "AccountReceivable",
  titleKey: "delivery_note",
  schema: deliveryNoteSchema,
  preserveOnReset: vendorPreserve,
  hiddenSections: ["recurring"],
  mapUserProfile: (data) => ({
    ...defaultVendorProfileMapper(data),
    vendorCompanyAddress: data.companyAddress ?? "",
  }),
  sections: {
    vendor: {
      hiddenFields: [
        "vendorCountry",
        "vendorCompanyStreet",
        "vendorCompanyStreetNumber",
        "vendorCompanyLocality",
        "vendorCompanyZipCode",
        "vendorCompanyRegion",
      ],
      extraFields: [
        {
          id: "vendorCompanyAddress",
          grid: { xs: 12, md: 6 },
          render: ({ translate }) => (
            <RHFTextField
              name="vendorCompanyAddress"
              label={translate("companyAddress")}
              fullWidth
            />
          ),
        },
      ],
    },
    customer: {
      hiddenFields: [
        "customerCountry",
        "customerCompanyStreet",
        "customerCompanyStreetNumber",
        "customerCompanyLocality",
        "customerCompanyZipCode",
        "customerCompanyRegion",
      ],
    },
  },
});
